import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '../../ea/globals.js'
import rte from '../rte.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as lightbox from '../../lightboxes/lightbox.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button
  ) => {
    const container = closest('[data-contract="modal.backdrop"]', button)
    const origin = lightbox.opener(container)
    const form = one('form', origin)
    const { id } = one('iframe[data-rte]', form)
    const { value: urlValue } = one('[type="text"][name="url"]', container)

    if (id && urlValue) {
      globals.ea_rte_exec_insert_link(id, urlValue, 'link')
    }

    one('[data-contract="modal.close"] ', container)?.click()
  }
})

export const highlight = (
  button,
  modifier,
  text
) => {
  if (closest('a', text)) {
    button.classList.add(modifier)
  }
}

export default button => {
  onClick.listen(button)
  rte(button, object(null, { highlight }))
}
